import React from 'react';
import {
  TextField,
  Box,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
} from '@mui/material';

const ApprovalForm = ({ apprDoc, formik }) => {
  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        px: 1.5,      // 패딩 축소
        py: 0.3,      // 상하 여백 최소화
      }}
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      {/* 상단 결재 정보 요약 (기존 텍스트 표현 유지) */}
      <Box sx={{ mb: 0.2 }}>
        <Typography 
          sx={{ color: '#1976d2', fontWeight: 'bold', fontSize: '0.8rem' }}
        >
          결재 타입:{apprDoc?.docyTyp} | 결재 단계:{apprDoc?.docuStep} | 현재 결재자:{apprDoc?.docuUsrNm}{apprDoc?.docuUsrGradeNm}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 2,
          height: '34px', // 전체 높이 슬림하게 고정
        }}
      >
        {/* 결재 여부 영역 (기존 라벨 유지) */}
        <Box sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
          <Typography 
            sx={{ 
              fontSize: '0.85rem', 
              fontWeight: 'bold', 
              color: 'text.secondary',
              mr: 1.5 
            }}
          >
            결재 여부
          </Typography>
          <RadioGroup
            row
            name="docuYn"
            value={formik.values.docuYn || 'Y'}
            onChange={(e) => formik.setFieldValue('docuYn', e.target.value)}
          >
            <FormControlLabel 
              value="Y" 
              control={<Radio size="small" sx={{ p: 0.5 }} />} 
              label={<Typography sx={{ fontSize: '0.85rem' }}>승인</Typography>} 
              sx={{ m: 0, mr: 1 }} 
            />
            <FormControlLabel 
              value="N" 
              control={<Radio size="small" sx={{ p: 0.5 }} />} 
              label={<Typography sx={{ fontSize: '0.85rem' }}>비승인</Typography>} 
              sx={{ m: 0 }} 
            />
          </RadioGroup>
        </Box>

        {/* 참고사항 입력창 (기존 placeholder 유지) */}
        <TextField
          variant="standard"
          id="docuTxt"
          name="docuTxt"
          placeholder="참고사항을 입력해 주세요"
          value={formik.values.docuTxt}
          onChange={formik.handleChange}
          error={formik.touched.docuTxt && Boolean(formik.errors.docuTxt)}
          sx={{ 
            flex: 1,
            '& .MuiInput-input': { fontSize: '0.9rem', py: '2px' } 
          }}
        />

        {/* 결재 버튼 (사이즈 축소) */}
        <Button
          type="submit"
          color="primary"
          variant="contained"
          disabled={formik.isSubmitting}
          sx={{ 
            minWidth: '65px',
            height: '28px', 
            fontSize: '0.85rem',
            fontWeight: 'bold', 
            boxShadow: 'none',
            whiteSpace: 'nowrap'
          }}
        >
          결재
        </Button>
      </Box>
    </Box>
  );
};

export default ApprovalForm;
